import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class GtmService {
  private static readonly PUSH_FLAG = '__user_id_pushed__';

  constructor() {
    sessionStorage.setItem(GtmService.PUSH_FLAG, '0');
    sessionStorage.setItem('__env_context_pushed__', '0');
  }

  pushEvent(event: any, fromHeader?: boolean) {
    globalThis.dataLayer = globalThis.dataLayer || [];
    if (fromHeader) globalThis.dataLayer.unshift(event);
    else globalThis.dataLayer.push(event);
  }

  pushEventAfterGtmStart(event: any, dedupeKey?: string, timeoutMs = 5000) {
    const key = dedupeKey || JSON.stringify(event);
    if (sessionStorage.getItem(key) === '1') return;

    void (async () => {
      await this.waitForGtmReady(timeoutMs);
      this.pushEvent(event);
      sessionStorage.setItem(key, '1');
    })();
  }

  setUserIdAfterGtmStart(
    userId: string,
    fireLoginEvent = true,
    timeoutMs = 5000
  ) {
    if (!userId) return;

    const flag = GtmService.PUSH_FLAG;
    if (sessionStorage.getItem(flag) === '1') return;

    void (async () => {
      await this.waitForGtmReady(timeoutMs);
      try {
        globalThis.gtag?.('set', { user_id: userId });
      } catch (err) {
        console.debug('gtag user_id setup skipped', err);
      }

      if (fireLoginEvent) {
        this.pushEvent({ event: 'user_login_successfully', user_id: userId });
      }

      sessionStorage.setItem(flag, '1');
    })();
  }

  private waitForGtmReady(timeoutMs: number): Promise<void> {
    return new Promise((resolve) => {
      const start = Date.now();
      const ready = () => {
        const gtm = globalThis.google_tag_manager;
        return !!gtm && Object.keys(gtm).some((k) => k.startsWith('GTM-'));
      };
      const tick = () => {
        if (ready()) return resolve();
        if (Date.now() - start >= timeoutMs) return resolve();
        setTimeout(tick, 100);
      };
      tick();
    });
  }
}
